var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgVideoPlay = function SvgVideoPlay(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 17.0833,
    height: 17.9149,
    viewBox: "-1.4583 -1.0426 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.15667 1.49422C2.835 0.775886 1.25 1.72422 1.25 3.15172V14.7634C1.25 16.1917 2.835 17.1392 4.15667 16.4209L14.8333 10.6151C16.1667 9.89005 16.1667 8.02505 14.8333 7.30089L4.15667 1.49422ZM0 3.15172C0 0.730886 2.63917 -0.754114 4.75417 0.39672L15.4308 6.20255C17.6342 7.40089 17.6342 10.5142 15.4308 11.7126L4.75417 17.5184C2.63917 18.6684 0 17.1851 0 14.7634V3.15172Z",
    fill: "white"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgVideoPlay);
export default ForwardRef;